import CloudProHeader from "./CloudProHeader";
import CloudProMenu from "./CloudProMenu";
import { Outlet } from "react-router-dom";

export default function CloudProLayout() {
  return (
    <>
      <CloudProHeader />
      <CloudProMenu />

      <div className="">
        <Outlet />
      </div>
        <footer className="cloudpro-footer">
        &copy; {new Date().getFullYear()} Velox Life Safety Inc. All rights reserved.
      </footer>
    </>
  );
}